export interface SelectedRentRange {
  minRent?: number;
  maxRent?: number;
}

export function mergeSelectedRentRange(
  current: SelectedRentRange,
  ...values: Array<number | undefined>
): SelectedRentRange {
  let minRent = current.minRent;
  let maxRent = current.maxRent;

  for (const value of values) {
    if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) continue;
    minRent = minRent === undefined ? value : Math.min(minRent, value);
    maxRent = maxRent === undefined ? value : Math.max(maxRent, value);
  }

  return { minRent, maxRent };
}
